/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-11-12 16:28:16
 * @LastEditTime: 2020-11-13 09:41:29
 */
// wifi信道选项
export const channelOptions = [
  { label: 'auto', value: 'auto'},
  { label: '1 (2412 MHz)', value: '1'},
  { label: '2 (2417 MHz)', value: '2'},
  { label: '3 (2422 MHz)', value: '3'},
  { label: '4 (2427 MHz)', value: '4'},
  { label: '5 (2432 MHz)', value: '5'},
  { label: '6 (2437 MHz)', value: '6'},
  { label: '7 (2442 MHz)', value: '7'},
  { label: '8 (2447 MHz)', value: '8'},
  { label: '9 (2452 MHz)', value: '9'},
  { label: '10 (2457 MHz)', value: '10'},
  { label: '11 (2462 MHz)', value: '11'},
  { label: '12 (2467 MHz)', value: '12'},
  { label: '13 (2472 MHz)', value: '13'},
]
// 频宽选项
export const htmodeOptions = [
  { label: '20 MHz', value: 'HT20'},
  { label: '40 MHz', value: 'HT40'},
]

